import { Col, message, Row, Tabs } from "antd";
import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import contentApi from "../../../api/contentApi";
import TopContent from "../../../components/TopContent";
import PageWrap from "../../../layout/PageWrap";
import { labels } from "../../../utils/constants";
import { messages } from "../../../utils/messages";
import TermForm from "./TermForm";

const Term = () => {
  const queryClient = useQueryClient();
  const [idx, setIdx] = useState(0);

  const { data, isLoading, isFetching } = useQuery(
    ["content_term", idx === 0 ? "vi" : "en"],
    () => contentApi.getTerm(idx === 1)
  );

  const mutation = useMutation(contentApi.editTerm, {
    onSuccess: (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.updateSuccess);
        queryClient.invalidateQueries([
          "content_term",
          idx === 0 ? "vi" : "en",
        ]);
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  const onSubmit = (dt: any) => {
    mutation.mutate({ data: dt, en: idx === 1 });
  };

  return (
    <PageWrap
      title="Điều khoản"
      content={
        <>
          <TopContent
            content={
              <Row>
                <Col>
                  <b>Điều khoản</b>
                </Col>
              </Row>
            }
          />
          <div className="content">
            <Tabs
              type="card"
              onChange={(e: any) => {
                setIdx(e);
                queryClient.invalidateQueries([
                  "content_term",
                  e === 0 ? "vi" : "en",
                ]);
              }}
              items={labels.map((item: any, i: any) => {
                return {
                  label: item,
                  key: i,
                  children: (
                    <TermForm
                      loading={isLoading || isFetching}
                      baomat={data?.data?.baomat}
                      dieukhoan={data?.data?.dieukhoan}
                      quydinh={data?.data?.quydinh}
                      onSubmit={onSubmit}
                    />
                  ),
                };
              })}
            />
          </div>
        </>
      }
    />
  );
};

export default Term;
